<template>
  <SimpleModuleDashboard
    :module-id="Modules.INSTANCIAS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="actions"
    :widget-filter="filterWidgets"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    integrateServices: Helper.hasParametersAccess(Param.P59),
    actions: [
      { id: 'crudInstancesCategories', reference: 'crudInstancesCategories', route: 'InstancesStaffCrudInstancesCategories', tone: 'primary', group: 'Configuraciones' },
      { id: 'crudInstancesServer', reference: 'crudInstancesServer', route: 'InstancesStaffCrudInstancesServer', tone: 'secondary', group: 'Configuraciones' },
      { id: 'crudInstancesSystem', reference: 'crudInstancesSystem', route: 'InstancesStaffCrudInstancesSystem', tone: 'success' },
      { id: 'crudInstancesSystemOthers', reference: 'crudInstancesSystemOthers', route: 'InstancesStaffCrudInstancesSystemOthers', tone: 'warning' },
      { id: 'crudInstancesSystemDocker', reference: 'crudInstancesSystemDocker', route: 'InstancesStaffCrudInstancesSystemDocker', tone: 'primary' },
    ],
  }),
  methods: {
    filterWidgets(widget) {
      return widget.reference !== 'list_instances_without_services' || this.integrateServices
    },
  },
}
</script>
